<template>
  <div class="builderContainer">
    <div class="added-panel-aramcco" style="float:left;top:0;position: fixed;background:4CAF50;padding:5px;border-radius:3px;">
    </div>
    <v-btn block :loading="loading" :disabled="loading" tile color="success" large @click="save()">save</v-btn>
    <v-text-field
      name="Name"
      solo
      :loading="loading" 
      :disabled="loading"
      hide-details
      label="Name"
      v-model="resource.name"
    ></v-text-field>
    <v-progress-circular v-if="loading" size="150" indeterminate color="primary"></v-progress-circular>
    <div id="gjs">
    </div>
    <!-- <div class="panel__top">
      <div class="panel__basic-actions"></div>
      <div class="panel__switcher"></div>
    </div>
    <div class="editor-row">
      <div class="editor-canvas">
        <div id="gjs"></div>
      </div>
      <div class="panel__right">
        <div class="layers-container"></div>
        <div class="styles-container"></div>
        <div id="blocks"></div>
      </div>
    </div> -->
  </div>
</template>

<script>

import 'grapesjs/dist/css/grapes.min.css';
import grapesjs from 'grapesjs';
import 'grapesjs-blocks-basic';
import 'grapesjs-preset-newsletter';
import de from 'grapesjs/locale/de';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

// If you need plugins, put them below the main grapesjs script
// import 'grapesjs-some-plugin';
export default {
  data(){
    return {
      resource:{},
      editor:null,
      loading:false,
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async save(){
      this.loading = true
      if(!this.resource.name) {
        this.resource.name = 'New Template'
      }
      console.log(this.editor.getHtml())
      this.resource.content = this.editor.getHtml()
      this.resource.style = this.editor.getCss() 
      console.log(this.resource)
      if(!this.resource.id) {
        let a = await axios.post(`https://crm.aramccogermany.com/back/public/api/v1/templates`, this.resource, {headers}).then(x=>x.data)
        console.log(a)
        if(!a.error) {
          this.goTo('/templates')
        }
      } else {
        let a = await axios.put(`https://crm.aramccogermany.com/back/public/api/v1/templates/${this.resource.id}`, this.resource, {headers}).then(x=>x.data)
        console.log(a)
        if(!a.error) {
          this.goTo('/templates')
        }
      }
      this.loading = false
    },
    async loadTemplate(id){
      return new Promise(async (res, rej)=>{
        let a = await axios.get(`https://crm.aramccogermany.com/back/public/api/v1/templates/${id}`, {headers}).then(x=>x.data)
        this.resource = a
        console.log(a)
        console.log(this.resource.content)
        document.getElementById('gjs').innerHTML = `<style>${a.style}</style>${a.content}` 
        res(a)
      })
    }
  },
  async mounted(){
    this.loading = true
    if(this.$route.params && this.$route.params.template) {
      let id = this.$route.params.template
      console.log(id)
      await this.loadTemplate(id)
    }
    const editor = grapesjs.init({
      // Indicate where to init the editor. You can also pass an HTMLElement
      container: '#gjs',
      // Get the content for the canvas directly from the element
      // As an alternative we could use: `components: '<h1>Hello World Component!</h1>'`,
      fromElement: true,
      // Size of the editor
      // width: '100%',
      // height: 'auto',
      // Disable the storage manager for the moment
      storageManager: false,
      // Default command
      // defaultCommand: 'show-blocks',
      // // Show a toolbar when the component is selected
      // showToolbar: 1,
      // // Starting tag for variable inside scripts in Components
      // tagVarStart: '*|',

      // // Ending tag for variable inside scripts in Components
      // tagVarEnd: '|*',
      // // Avoid any default panel
      // panels: {
      //   defaults: [
      //     {
      //       id: 'layers',
      //       el: '.panel__right',
      //       // Make the panel resizable
      //       resizable: {
      //         maxDim: 350,
      //         minDim: 200,
      //         tc: 0, // Top handler
      //         cl: 1, // Left handler
      //         cr: 0, // Right handler
      //         bc: 0, // Bottom handler
      //         // Being a flex child we need to change `flex-basis` property
      //         // instead of the `width` (default)
      //         keyWidth: 'flex-basis',
      //       },
      //     },
      //     {
      //       id: 'panel-switcher',
      //       el: '.panel__switcher',
      //       buttons: [{
      //           id: 'show-blocks',
      //           active: true,
      //           label: 'Blocks',
      //           command: 'show-blocks',
      //           togglable: false,
      //         },{
      //           id: 'show-layers',
      //           active: true,
      //           label: 'Layers',
      //           command: 'show-layers',
      //           // Once activated disable the possibility to turn it off
      //           togglable: false,
      //         }, {
      //           id: 'show-style',
      //           active: true,
      //           label: 'Styles',
      //           command: 'show-styles',
      //           togglable: false,
      //       }],
      //     }
      //   ]
      // },
      // selectorManager: {
      //   appendTo: '.styles-container'
      // },
      // styleManager: {
      //   appendTo: '.styles-container',
      //   sectors: [{
      //       name: 'Dimension',
      //       open: false,
      //       // Use built-in properties
      //       buildProps: ['width', 'min-height', 'padding'],
      //       // Use `properties` to define/override single property
      //       properties: [
      //         {
      //           // Type of the input,
      //           // options: integer | radio | select | color | slider | file | composite | stack
      //           type: 'integer',
      //           name: 'The width', // Label for the property
      //           property: 'width', // CSS property (if buildProps contains it will be extended)
      //           units: ['px', '%'], // Units, available only for 'integer' types
      //           defaults: 'auto', // Default value
      //           min: 0, // Min value, available only for 'integer' types
      //         }
      //       ]
      //     },{
      //       name: 'Extra',
      //       open: false,
      //       buildProps: ['background-color', 'box-shadow', 'custom-prop'],
      //       properties: [
      //         {
      //           id: 'custom-prop',
      //           name: 'Custom Label',
      //           property: 'font-size',
      //           type: 'select',
      //           defaults: '32px',
      //           // List of options, available only for 'select' and 'radio'  types
      //           options: [
      //             { value: '12px', name: 'Tiny' },
      //             { value: '18px', name: 'Medium' },
      //             { value: '32px', name: 'Big' },
      //           ],
      //       }
      //       ]
      //     }]
      // },
      // blockManager: {
      //   appendTo: '#blocks',
      //   blocks: [
      //     {
      //       id: 'section', // id is mandatory
      //       label: '<b>Section</b>', // You can use HTML/SVG inside labels
      //       attributes: { class:'gjs-block-section' },
      //       content: `<section>
      //         <h1>This is a simple title</h1>
      //         <div>This is just a Lorem text: Lorem ipsum dolor sit amet</div>
      //       </section>`,
      //     }, {
      //       id: 'text',
      //       label: 'Text',
      //       content: '<div data-gjs-type="text">Insert your text here</div>',
      //     }, {
      //       id: 'image',
      //       label: 'Image',
      //       // Select the component once it's dropped
      //       select: true,
      //       // You can pass components as a JSON instead of a simple HTML string,
      //       // in this case we also use a defined component type `image`
      //       content: { type: 'image' },
      //       // This triggers `active` event on dropped components and the `image`
      //       // reacts by opening the AssetManager
      //       activate: true,
      //     }
      //   ]
      // },
      // layerManager: {
      //   appendTo: '.layers-container'
      // },
      // We define a default panel as a sidebar to contain layers
      plugins: ["gjs-blocks-basic", "gjs-preset-newsletter"],
      pluginsOpts: {
        // "gjs-blocks-basic": {
        //   blocks:['column1', 'column2', 'column3', 'text', 'link', 'image'],
        // },
        "gjs-preset-newsletter": {
          modalTitleImport: 'Import template',
        }
      },
      // i18n: {
      //   locale: 'de', // default locale
      //   detectLocale: true, // by default, the editor will detect the language
      //   // localeFallback: 'en', // default fallback
      //   messages: { de },
      // }
    });
    
    // editor.Panels.addPanel({
    //   id: 'panel-top',
    //   el: '.panel__top',
    // });
    // editor.Panels.addPanel({
    //   id: 'exp-actions',
    //   el: '.added-panel-aramcco',
    //   buttons: [
    //     {
    //       id: 'save',
    //       className: 'btn-open-save',
    //       label: 'SAVE',
    //       command: 'savetomydb',
    //       context: 'gjs-get-inlined-html', // For grouping context of buttons from the same panel
    //     }, {
    //       id: 'show-jsona',
    //       className: 'btn-show-json',
    //       label: 'JSON',
    //       context: 'show-json',
    //       command(editor) {
    //         editor.Modal.setTitle('Components JSON')
    //           .setContent(`<textarea style="width:100%; height: 250px;">
    //             ${JSON.stringify(editor.getComponents())}
    //           </textarea>`)
    //           .open();
    //       },
    //     }
    //   ],
    // });
    // editor.on('run:export-template:before', opts => {
    //   console.log('Before the command run');
    //   if (0 /* some condition */) {
    //     opts.abort = 1;
    //   }
    // });
    // editor.on('run:export-template', () => console.log('After the command run'));
    // editor.on('abort:export-template', () => console.log('Command aborted'));
    // editor.Commands.add('show-layers', {
    //   getRowEl(editor) { return editor.getContainer().closest('.editor-row'); },
    //   getLayersEl(row) { return row.querySelector('.layers-container') },

    //   run(editor, sender) {
    //     const lmEl = this.getLayersEl(this.getRowEl(editor));
    //     lmEl.style.display = '';
    //   },
    //   stop(editor, sender) {
    //     const lmEl = this.getLayersEl(this.getRowEl(editor));
    //     lmEl.style.display = 'none';
    //   },
    // });
    // editor.Commands.add('savetomydb', {
    //   getRowEl(editor) { return editor.getContainer().closest('.editor-row'); },
    //   getStyleEl(row) { return row.querySelector('.styles-container') },

    //   run(editor, sender) {
    //     console.log(editor.getHtml())
    //     console.log({content:editor.getHtml()})
    //     // const smEl = this.getStyleEl(this.getRowEl(editor));
    //     // smEl.style.display = '';
    //   },
    //   stop(editor, sender) {
    //     // const smEl = this.getStyleEl(this.getRowEl(editor));
    //     // smEl.style.display = 'none';
    //   },
    // });
    this.editor = editor
    this.loading = false
    
    // editor.Commands.add('show-blocks', {
    //   getRowEl(editor) { return editor.getContainer().closest('.editor-row'); },
    //   getStyleEl(row) { return row.querySelector('#blocks') },

    //   run(editor, sender) {
    //     const smEl = this.getStyleEl(this.getRowEl(editor));
    //     smEl.style.display = '';
    //   },
    //   stop(editor, sender) {
    //     const smEl = this.getStyleEl(this.getRowEl(editor));
    //     smEl.style.display = 'none';
    //   },
    // });
  }
}
</script>

<style>
/* .builderContainer * {
  direction:rtl;
} */
/* #gjs {
  border: none;
} */
/* .gjs-cv-canvas {
  top: 0;
  width: 100%;
  height: 600px;
} */
/* 
.gjs-block {
  width: 100%;
  height: auto;
  min-height: auto;
}

.panel__top {
  padding: 0;
  width: 100%;
  display: flex;
  position: initial;
  justify-content: center;
  justify-content: space-between;
}

.panel__basic-actions {
  position: initial;
}

.editor-row {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: nowrap;
  height: auto;
}

.editor-canvas {
  flex-grow: 1;
}

.panel__right {
  flex-basis: 230px;
  position: relative;
  overflow-y: auto;
}

.panel__switcher {
  position: initial;
} */

.gjs-one-bg {
  background-color: #092270;
}

/* Secondary color for the text color */
.gjs-two-color {
  color: rgba(255, 255, 255, 0.7);
}

/* Tertiary color for the background */
.gjs-three-bg {
  background-color: #092270;
  color: white;
}

/* Quaternary color for the text color */
.gjs-four-color,
.gjs-four-color-h:hover {
  color: white;
}
</style>